export const ADD_PLUGIN_LINK_BI = 'addPluginLink';
export const WEB_ADDRESS_CATEGORY = 'web_address';
export const ANCHOR_CATEGORY = 'section';
export const LINK_VIEWER_DATA_HOOK = 'linkViewer';
export const MEDIA_POPOVERS_BUTTONS_NAMES_BI = {
  embed: 'ClickEmbed',
  upload: 'ClickUpload',
  cancel: 'ClickCancel',
};
export const MEDIA_POPOVERS_TABS_NAMES_BI = { embed: 'ClickEmbedTab', upload: 'ClickUploadTab' };
export const MAX_LIST_VISIBLE_INDENTATION = 4;
